// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { defaultBillingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress";
import Edit from "@steiner/XDL/Icons/Edit";
import { createLinkIconStyles, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

defaultBillingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "xs")} {
            justify-content: space-between;
        }
    `,
};

defaultBillingAddressStyles.customerSelectorModalCancelButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

defaultBillingAddressStyles.editLink = {
    ...createLinkIconStyles({
        icon: Edit,
        linkStyles: {
            css: css`
                margin-left: 30px;
                margin-top: 6px;
                white-space: nowrap;
            `,
        },
    }),
};
